import { useQuery } from "@tanstack/react-query";
import { IServiceOrderItem } from "../declarations";
import { createApiClient } from "../utilities/apiClient";

const GetSailInfoServiceOrderItems = async (
    guid: string,
): Promise<IServiceOrderItem[]> => {
    const axiosSailTag = createApiClient();
    const response = await axiosSailTag.get<IServiceOrderItem[]>(
        `/api/SailInfo/GetSailInfoServiceOrderItems/${encodeURIComponent(guid)}`,
    );
    return response.data;
};

export const useGetSailInfoServiceOrderItems = (guid: string) =>
    useQuery<IServiceOrderItem[]>({
        queryKey: [
            "GetSailInfoServiceOrderItems",
            {
                guid: guid ?? null,
            },
        ],
        queryFn: () => {
            if (!guid?.trim()) {
                throw new Error("Invalid params for GetSailInfoServiceOrderItems");
            }
            return GetSailInfoServiceOrderItems(guid);
        },
        enabled: Boolean(guid?.trim()),
        refetchOnWindowFocus: true,
        retry: false,
        placeholderData: [],
    });
